import avatar1 from "../../../assets/images/avatars/ToyFaces_Colored_BG_2.jpg"
import avatar2 from "../../../assets/images/avatars/ToyFaces_Colored_BG_33.jpg"

type PageModeType = "role-selection" | "enterprise-form" | "service-provider-form"

interface Props {
    onSelect: (role: PageModeType) => void
}
const SelectRoleView = (props: Props) => {

    const { onSelect } = props

    return <div className="role-selection-section">
        <h2>Discover Your Platform Role</h2>
        <div className="role-options-wrapper">
            <div className="option-container">
                <div onClick={() => { onSelect("enterprise-form") }} className="option">
                    <img alt="Enterprise" src={avatar1} />
                    <h3>Enterprise</h3>
                    <p>Onboards the platform as a business entity and can access various features offered.</p>
                </div>
                <span className="note mt-5">Click <a href="https://dev.emplifive.com">here</a> to discover our Marketing Game Changer features</span>
            </div>
            <div className="option-container left">
                <div className="option">
                    <img alt="Talent Agencies" src={avatar2} />
                    <h3>Talent Agencies</h3>
                    <p>Manages talents, and conduct campaigns for Enterprises on the platform.</p>
                </div>
                <span className="note mt-5">Click <a href="https://dev.emplifive.com">here</a> to learn how you can profit from Emplfive</span>
            </div>
        </div>
    </div >
}
export default SelectRoleView